import { Color } from '@mui/material';
import { pipe, sort, take, map, split, append } from 'ramda';

import { AxisConfig, ItemConfig } from './BaseChart.types';

type ColorShade = keyof Color;
const colorShades: ColorShade[] = [500, 300, 600, 800, 200];

export const MARGIN = { top: 20 };

const sortColorShadeDesc = (a: ColorShade, b: ColorShade) => (b as number) - (a as number);

export const Y_AXIS: any = {
  domain: [0, 'auto'],
  scale: 'linear',
  tickSize: 8,
  width: 70,
};
export const X_AXIS: any = {
  interval: 0,
  axisLine: false,
  tickLine: false,
  height: 60,
  padding: { left: 40, right: 40 },
  dy: 20,
};

export const getColorShades = (len: number, color: Color): string[] => {
  return pipe(
    // take as many colors than number lines/bars
    take(len),
    // sort from dark to light
    sort(sortColorShadeDesc),
    // get color from shade
    map((shade) => color[shade]),
  )(colorShades);
};

export const labelPath = pipe(split('.'), append('label'));

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getTooltipFormatter = (yAxis?: AxisConfig, dataConfig?: ItemConfig) => (value: any, name: string) => {
  const formatter = yAxis?.tickFormatter;
  return [formatter ? formatter(value ?? 0) : (value ?? 0), dataConfig?.label || name];
};
